import { AFFICHAGE, LAISSER_EN_PLACE_VENTE, MANUEL } from '@/configuration/logistique/facesDisponible/facesDisponibleConf';

export default function estAffectee(tfs) {
  return tfs.actionLogistique === AFFICHAGE
    || tfs.actionLogistique === LAISSER_EN_PLACE_VENTE
    || (tfs.actionLogistique === MANUEL && !!tfs.affectationLogistiqueLigneCommandeLibelle);
}
